import { useNavigate } from "react-router-dom";
import ButtonGroup from "../../../components/ui/ButtonGroup";
import TitleStyles from "../../../components/ui/TitleStyles";
import { Container, Notice } from "./PreviewStyles";
import PressKitPreview from "../../../components/pressKitPreview/PressKitPreview";
import { usePressKit } from "../../../context/PressKitContext";
import { isPressKitEmpty } from "../../../utils/isPressKitEmpty";

const Preview = () => {
  const navigate = useNavigate();
  const { pressKitData } = usePressKit();

  const isEmpty = isPressKitEmpty(pressKitData);

  return (
    <Container>
      <TitleStyles>Pré visualização</TitleStyles>

      <ButtonGroup
        onBack={() => navigate("/logged-home")}
        onNext={() => navigate("/share")}
        backLabel="< Salvar"
        nextLabel="Publicar >"
      />

      {isEmpty ? (
        <Notice>Você ainda não preencheu seu press kit.</Notice>
      ) : (
        <PressKitPreview data={pressKitData} />
      )}
    </Container>
  );
};

export default Preview;
